import React, {Component} from 'react'
import PropTypes from "prop-types";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";

class PatientSelectComponent extends Component {
    constructor(props) {
        super();
        this.state = {
            docWidth: document.body.offsetWidth,
        }
    }

    componentDidMount() {
        const self = this;
        window.addEventListener('resize', function (event) {
            self.setState({docWidth: document.body.offsetWidth})
        }, true);
    }

    render() {
        let {rest} = this.props
        let {docWidth} = this.state
        let width=this.props.selectWidth&& docWidth>1350?this.props.selectWidth:docWidth>1350?'19.6vw':'94%'
        let minWidth ="288px"
        let currentUser=authenticationService.currentUserValue;
        let marginLeft=this.props.marginLeft?this.props.marginLeft:docWidth>1350?"35px":"0px"
        let marginRight=this.props.marginRight?this.props.marginRight:"13px"

        let language =localStorage.getItem('language')
        let align ='left'
        if(language==="he") {
            align ='right'
            marginLeft="13px"
            marginRight=docWidth>1350?"35px":"0px"
        }
        return <Select
            isSearchable={this.props.isSearchable}
            placeholder={this.props.placeholder}
            name={this.props.name}
            isMulti={this.props.isMulti}
            options={this.props.options}
            className={`sade-Select ${this.props.className}`}
            isDisabled={this.props.disabled}
            value={this.props.value}
            defaultValue={this.props.defaultValue}
            onInputChange={inputValue =>
                this.props.maxLength? (inputValue.length <= 20 ? inputValue : inputValue.substr(0, 20)) : inputValue
            }
            onChange={e => this.props.onChange(e)}
            styles={{
                dropdownIndicator: (base, state) => ({
                    ...base,
                    color: "#005f7f",
                    display: this.props.isSearchable ? "none" : 'block'
                }),
                indicatorSeparator: (base, state) => ({
                    ...base,
                    display: "none"
                }),
                container: (base, state) => ({
                    ...base,
                    padding: "0px",
                    height: '40px',
                    fontSize: '18px',
                    cursor: this.props.isSearchable ? 'text' : 'default',
                    boxShadow: "0",
                }),
                menu: (base, state) => ({
                    ...base,
                    color: "#000000",
                    marginLeft:marginLeft,
                    marginRight:marginRight,
                    width:width,
                    minWidth:minWidth,
                    maxWidth:width,
                    textAlign:align,
                }),
                multiValueLabel: (base, state) => ({
                    fontSize: '18px',
                    fontFamily:'Assistant, sans-serif'
                }),
                control: (base, state) => ({
                    ...base,
                    padding: "0px",
                    marginLeft:marginLeft,
                    marginRight:marginRight,
                    marginBottom:"13px",
                    minHeight:"45px",
                    minWidth:minWidth,
                    width:width,
                    borderRadius:'10px',
                    cursor: this.props.isSearchable ? 'text' : 'default',
                    boxShadow: "0",
                    border:state.isFocused ? 'solid 0.5px #005f7f' : 'solid 0.5px #e1e1e1',
                    "&:hover": {
                        outline: "solid 1px #e1e1e1;"
                    },
                }),
            }}
            {...rest}
        />
    }
}

/*.css-2b097c-container{
    padding: 0px!important;
    outline: none;
}
.styled__control-is-focused{
    outline: yellow;
}
.css-19bqh2r{
    display: none!important;
}
. css-1wy0on6{
    display: none!important;
}*/

PatientSelectComponent.propTypes = {
    name: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.string,
    defaultValue: PropTypes.object,
    onChange: PropTypes.func,
    isSearchable: PropTypes.bool,
    rest: PropTypes.object,
    disabled: PropTypes.bool,
    maxLength: PropTypes.number
}

export default PatientSelectComponent;
